module.exports = __webpack_public_path__ + "img/SELLANTE_PRESENTE.png";